var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIc33Estate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 17.3904L19.9485 10.4883L34.897 17.3904V32.4128H5V17.3904Z",
    fill: "#E7E0D5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44531 24.1506C9.44531 22.0309 11.1637 20.3125 13.2834 20.3125V20.3125C15.4032 20.3125 17.1216 22.0309 17.1216 24.1506V32.4329H9.44531V24.1506Z",
    fill: "#B0A086"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4531 10.6163C30.4531 9.94694 30.9958 9.4043 31.6652 9.4043H33.6852C34.3546 9.4043 34.8973 9.94694 34.8973 10.6163V16.2725H30.4531V10.6163Z",
    fill: "#C92863"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 16.1149C5 14.5032 5.95799 13.0456 7.43753 12.4063L18.3459 7.69252C19.3686 7.25059 20.5284 7.25059 21.5511 7.69252L32.4595 12.4063C33.939 13.0456 34.897 14.5032 34.897 16.1149V18.4605L19.9485 12.001L5 18.4605L5 16.1149Z",
    fill: "#DE578D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3906 22.7365C24.3906 22.0671 24.9333 21.5244 25.6027 21.5244H27.2187C27.8881 21.5244 28.4308 22.0671 28.4308 22.7365V25.5645H24.3906V22.7365Z",
    fill: "#B0A086"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc33Estate);
export default __webpack_public_path__ + "static/media/Ic3.3Estate.2cc2aefaf6eb2943b67c320d8d1a3c0d.svg";
export { ForwardRef as ReactComponent };